import React from 'react';

import { FILE_BASE_URL } from 'variables';
import { WebImageProps } from 'types/webImageProps';

import { PayoffForYou } from 'components/forYou/PayoffForYou';
import { TransparentContainer } from 'components/common/TransparentContainer';
import { FlexContainer } from 'components/common/FlexContainer';

import { ColoredBackground } from './atoms/ColoredBackground';
import { Image } from './atoms/Image';
import { PayoffWrapper } from './atoms/PayoffWrapper';

const extraHeightInPixels = 200;

interface Props {
    description: string;
    title: string;
    isPurple?: boolean;
    image: WebImageProps;
}
export const ImagePayoff: React.FC<Props> = ({ image, description, title, isPurple }) => {
    return (
        <ColoredBackground isPurple={isPurple}>
            <Image src={FILE_BASE_URL + image.webPPath} fallback={FILE_BASE_URL + image.imagePath} />
            <PayoffWrapper>
                <FlexContainer>
                    <TransparentContainer>
                        <PayoffForYou
                            description={description}
                            title={title}
                            extraHeightInPixels={extraHeightInPixels}
                        />
                    </TransparentContainer>
                </FlexContainer>
            </PayoffWrapper>
        </ColoredBackground>
    );
};
